import { render, staticRenderFns } from "./ProductionItem.vue?vue&type=template&id=5ea87fc8&"
import script from "./ProductionItem.vue?vue&type=script&lang=js&"
export * from "./ProductionItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductionItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports